import React, { useEffect, useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';

import Logo from 'components/Logo';
import poweredBy from 'assets/images/powered_by_pharmaforce.svg';
import useOidc from 'hooks/useOidc';
import user from "assets/icon/user-icon.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";


const Header = () => {
  const { logout } = useOidc();
  const [hidePoweredBy, setHidePoweredBy] = useState(false);
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const interval = setInterval(() => { }, 1000);
    const { username } = profile || {};
    setUserName(username);
    const theme = sessionStorage.getItem('theme') || "PF";

    if (theme === "PF") setHidePoweredBy(true);

    if (!access_token) {
      navigate('/');
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    logout();
  };

  return (
    <>
      <Navbar color='white' light className='py-1 app-header'>
        <div className='d-flex align-items-center'>
          <NavbarBrand href='/' className='me-0'>
            <Logo height={50} />
          </NavbarBrand>
          <h2 className='ps-3 f-20 ms-3 d-inline mx-1 mt-1 mb-0 top_hed' style={{color:"#2A2A2A"}}>
          Reports Center
          </h2>
        </div>
        <div className='ms-auto powered-by'>
          <img src={poweredBy} title='' alt='' hidden={hidePoweredBy} />
        </div>

        {(
          <Nav className='ps-4'>
            {/* <UncontrolledDropdown nav className='profile-dropdown'>
              <DropdownToggle nav caret className='font-weight-500'>
                {!isEmpty(data) ? data.firstName + ' ' + data.lastName : ''}
                {userName}
              </DropdownToggle>
              <DropdownMenu className='shadow'>
                <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}
            
              <UncontrolledDropdown nav className="profile-dropdown login_info">
                <DropdownToggle nav className="">
                  <OverlayTrigger
                    overlay={(props) => (
                      <Tooltip {...props}>View Profile</Tooltip>
                    )}
                    placement="bottom"
                  >
                    {/* <FontAwesomeIcon icon={faUser} className="fa-fw text-dark topicons" style={{ width: '25px', height: '25px' }} /> */}

                    <img src={user} alt="" />
                  </OverlayTrigger>
                </DropdownToggle>
                <DropdownMenu className="shadow">
                  <DropdownItem>
                    <div id="app">
                      <div className="text-end">
                        <div
                          className="text-start"
                        // style={{ marginLeft: "0px", zIndex: 9999999 }}
                        >
                          <div className="">
                            <div
                              id="circle-avatar"
                              className="text-center mx-auto mb-4 h3"
                            >
                              {userName[0]}
                            </div>

                            <h5
                              className="text-center"
                              style={{ whiteSpace: "normal" }}
                            >
                              {userName}
                            </h5>
                            {/* <p className="text-center mb-2">jd@gmail.com</p> */}

                            {/* <hr /> */}

                            {/* <hr className="mb-0" style={{ margin: "0 -24px 0" }} /> */}

                            {/* <div
                              className="list-group list-group-flush"
                            // style={{ margin: "0 -24px 0" }}
                            >
                              <button onClick={showUserGuide} className="list-group-item list-group-item-action">
                                <small>User Guide</small>
                              </button>
                              <button className="list-group-item list-group-item-action">
                                <small>Change Requests</small>
                              </button>
                              <button className="list-group-item list-group-item-action">
                                <small>Pending Requests</small>
                              </button>
                              <button className="list-group-item list-group-item-action">
                                <small>Other Requests</small>
                              </button>
                            </div> */}

                            {/* <hr style={{ margin: "0 -24px 24px" }} /> */}

                            <div className="d-grid">
                              <button
                                className="btn btn-secondary"
                                onClick={handleLogout}
                              >
                                <small>Logout</small>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
          </Nav>
        )}
      </Navbar>
    </>
  );
};

export default Header;